import { GridItem, Text } from '@chakra-ui/react';
import React from 'react';

interface DetailItemProps {
  label: string;
  value: React.ReactNode;
}

export const DetailItem = ({ label, value }: DetailItemProps) => {
  return (
    <GridItem>
      <Text fontSize="sm" color="gray.500" casing="uppercase">
        {label}
      </Text>
      <Text fontWeight="medium">{value || '–'}</Text>
    </GridItem>
  );
};